import React, {useState, useEffect} from 'react'
import {default as EventtickerMarket} from './market';
import {Icon, Transition} from 'semantic-ui-react';
import * as moment from 'moment'
import * as EventtickerActions from '../../actions/EventtickerActions';
import { useFirestore } from 'react-redux-firebase';
import {useDispatch} from 'react-redux';
import {Responsive} from '../Responsive'
import * as STATUS_TO_COLOR from '../../constants/StatusToColor'

export default function Schedule(props) {
    let event = props.event;
    let [mounted, setMounted] = React.useState(false);

    const firestore = useFirestore();
    const dispatch = useDispatch();

    useEffect(() => {
        setTimeout(() => {
            setMounted(true);
        }, 100);
    }, [event.id]);

    return (
        <Transition.Group animation='slide right' duration={500}>
            {
                mounted?
                    <div style={{
                        display: 'flex',
                        width: '100%',
                        borderBottom: '1px solid #444444'
                    }}>
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap'
                        }}>
                            <div style={{
                                width: '80px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '2px 5px 2px 0px',
                                flexShrink: 0,
                                display: 'none'
                            }}>
                                {
                                    event.type
                                }
                            </div>

                            <div style={{
                                width: '90px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '2px 5px 2px 0px',
                                flexShrink: 0
                            }}>
                                {
                                    moment(event.timestamp.toDate()).format('DD.MM.YYYY')
                                }
                            </div>
                            <div style={{
                                width: '80px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '2px 0px 2px 10px',
                                flexShrink: 0
                            }}>
                                {
                                    moment(event.timestamp.toDate()).format('HH:mm:ss')
                                }
                            </div>

                            <div style={{
                                width: '50px',
                                textAlign: 'center',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '2px 5px 2px 5px',
                                fontWeight: 'bold',
                                backgroundColor: '#0090D7',
                                flexShrink: 0,
                                cursor: 'pointer'
                            }} onClick={(e) => {
                                dispatch(EventtickerActions.select_oe(firestore, event['uid'], event['plus-id']));
                            }}>
                                {
                                    event['plus-id']
                                }
                            </div>

                            <div style={{
                                width: '130px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '2px 0px 2px 10px',
                                flexShrink: 0
                            }}>
                                {
                                    (Array.isArray(event.event['active-to']))?
                                        <div>
                                            <div style={{
                                                textDecoration: 'strike-through',
                                                fontSize: '70%',
                                                color: '#999999'
                                            }}>
                                                {(typeof event.event['active-to'][0] !== 'undefined')?moment(event.event['active-to'][0].toDate()).format('DD.MM.YYYY HH:mm'):''} <Icon name="arrow right" />
                                            </div>
                                            <div style={{
                                                color: '#FFFF00'
                                            }}>
                                                {(typeof event.event['active-to'][1] !== 'undefined')?moment(event.event['active-to'][1].toDate()).format('DD.MM.YYYY HH:mm'):null}
                                            </div>
                                        </div>
                                    :
                                        moment(event.event['active-to'].toDate()).format('DD.MM.YYYY HH:mm')
                                }
                            </div>
                            <div style={{
                                flexGrow: 1,
                                flexShrink: 1,
                                padding: '2px 0px 2px 10px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: 'calc(100% - 120px)'
                            }}>
                                {event.event.name}
                            </div>

                            <div style={{
                                width: '100px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '2px 0px 2px 10px',
                                flexShrink: 0
                            }}>
                                {
                                    (typeof event.event.status === 'object')?
                                        <div>
                                            <div style={{
                                                textDecoration: 'strike-through',
                                                fontSize: '70%',
                                                color: '#999999'
                                            }}>
                                                {event.event.status[0]} <Icon name="arrow right" />
                                            </div>
                                            <div style={{
                                                display: 'inline-block',
                                                borderRadius: '5px',
                                                color: '#000000',
                                                padding: '3px 5px',
                                                textAlign: 'center',
                                                backgroundColor: (typeof STATUS_TO_COLOR[event.event.status[1]] !== 'undefined')?STATUS_TO_COLOR[event.event.status[1]]:'#FFFFFF'
                                            }}>
                                                {event.event.status[1]}
                                            </div>
                                        </div>
                                    :
                                        <div style={{
                                            color: (typeof STATUS_TO_COLOR[event.event.status] !== 'undefined')?STATUS_TO_COLOR[event.event.status]:'#FFFFFF'
                                        }}>{event.event['status']}</div>
                                }
                            </div>
                            <div style={{
                                width: '300px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '2px 0px 2px 10px',
                                flexShrink: 0
                            }}>
                                {
                                    (event.markets)?
                                        event.markets.map((market) => {
                                            return (
                                                <EventtickerMarket key={market['oddset-id']} market={market} />
                                            )
                                        })
                                    :null
                                }
                            </div>
                        </div>
                    </div>
                :null
            }
        </Transition.Group>
    )
}